import { Component, OnInit, HostListener } from '@angular/core';
import { LoginService } from 'src/app/services/login.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SharedDataService } from 'src/app/services/sharedDataService.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less']
})
export class LoginComponent implements OnInit {
  carouselList: any[] = []
  carouselImageWH: any = {
    width: `100%`,
    height: `500px`
  }
  pagination = {
    total: 50,
    pageIndex: 1,
    pageSize: 20,
  };
  params = {
    title: '',
    description: '',
    status: 1,
    salesOrg: []
  };
  get loggingTip(){
    return this.translate.instant('LOGGING_IN_TIP');
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.carouselImageWH = this.carouselImageStyle()
  }

  constructor(
    private loginService: LoginService, 
    private translate: TranslateService,
    private sanitizer: DomSanitizer,
    private sharedData: SharedDataService,
  ) { 
    const searchParams = new URLSearchParams(window.location.href.split('?')[1]);
    const codeValue = searchParams.get('code');
    const redirectUrl = environment.redirectUrl;
    if(codeValue){
      this.loginService.getToken({code:codeValue,redirectUrl:redirectUrl});
    }
  }
  carouselImageStyle(){
    const screenWidth = document.documentElement.clientWidth;
    /* aspectRatio: 1920 / 720; */
    const height = screenWidth / 1920 * 720
    return {
      width: `100%`,
      height: `${height}px`
    }
  }
  getList() {
    // this.isSpinning = true;
    const { title, status } = this.params; //salesOrg
    this.loginService.getBannerTableList({
      size: this.pagination.pageSize,
      current: this.pagination.pageIndex,
      title,
      status: 1,
      isAdmin: false
    }).subscribe(result => {
      const { rtnCode, rtnData } = result;
      if (rtnCode === 10000 && rtnData) {
        const { total, records } = rtnData;
        this.carouselList = records || [];
        this.carouselList.forEach(row => {
          row.imageBase64 = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpeg;base64,' + row.imageBase64);
        });
        this.pagination.total = total;
      }
    });
  }
  ngOnInit(): void {
    this.sharedData.updateData({ isDealerPortal: window.location.href.includes("Dealerportal") });
    this.carouselImageWH = this.carouselImageStyle()
  }

}
